import tokenHttpClient from "../utils/httpClient";
import {
  post,
  postFile,
  getWithURLFileDownload,
  postRequest,
} from "../utils/httpClient-methods";
import {
  API_URL,
  BASE_URL_MASTERS,
  BASE_URL,
  BRAND_LIST_API_URL,
  TECHNICAL_DOCUMENT_LIST_URL,
} from "../utils/AppApiUrl";

export const ServiceAdvisoryListService = async (requestBody) => {
  try {
    const requestObj = {
      advisoryPage: {
        pageSize: requestBody?.pageSize,
        pageNumber: requestBody?.pageNumber,
        sortDirection: requestBody?.sortDirection,
        sortBy: requestBody?.sortBy,
      },
      advisorySearchParam: {
        brandId: requestBody?.brandId,
        brickId: requestBody?.brickId,
        name: requestBody?.name,
        categoryId: requestBody?.categoryId,
        productFamilyId: requestBody?.productFamilyId,
        docTypeId: requestBody?.docTypeId ?? null,
        modelName: requestBody?.modelName ?? null,
        advisoryNumber: requestBody?.advisoryNumber ?? null,
        userId: requestBody?.userId ?? null,
        deptId: requestBody?.deptId ?? null,
        userType: requestBody?.userType ?? null,
        releaseDate: requestBody?.releaseDate ?? null,
        isDrafted: requestBody?.isDrafted ?? null,
      },
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.serviceAdvisoryListing}`,
      requestObj
    );
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const getAdvisoryDocListService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.serviceGetAdvisoryDocListing}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ServiceAdvisoryListOnSearchService = async (requestBody) => {
  try {
    const requestObj = {
      advisoryPage: {
        pageSize: requestBody?.pageSize,
        pageNumber: requestBody?.pageNumber,
        sortDirection: requestBody?.sortDirection,
        sortBy: requestBody?.sortBy,
      },
      advisorySearchParam: {
        brandId: requestBody?.brandId,
        brickId: requestBody?.brickId,
        categoryId: requestBody?.categoryId,
        productFamilyId: requestBody?.productFamilyId,
        docTypeId: requestBody?.docTypeId ?? null,
        modelName: requestBody?.modelName ?? null,
        advisoryNumber: requestBody?.advisoryNumber ?? null,
        userId: requestBody?.userId ?? null,
        deptId: requestBody?.deptId ?? null,
        userType: requestBody?.userType ?? null,
        releaseDate: requestBody?.releaseDate ?? null,
        isDrafted: requestBody?.isDrafted ?? null,
      },
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.serviceAdvisoryListing}`,
      requestObj
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const AllBrandListingService = async () => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL_MASTERS}${BRAND_LIST_API_URL.getAllBrandsListing}`,
      null
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const docTypeListingService = async () => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${TECHNICAL_DOCUMENT_LIST_URL.getDocTypeListing}`,
      null
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ServiceAdvisoryUploadService = async (file, requestBody) => {
  try {
    let formData = new FormData();
    if (file) {
      var multifile = [];
      for (let i = 0; i < file.length; i++) {
        formData.append("file", file[i]);
        multifile.push(file[i]);
      }
      formData.append("advisoryNumber", requestBody.advisoryNumber);
      formData.append("modelId", requestBody.modelId);
      formData.append("releaseDate", requestBody.releaseDate);
      formData.append("createdBy", requestBody.createdBy);
      formData.append("isDownloadAble", requestBody.isDownloadAble);
      formData.append("sendNotification", requestBody.sendNotification);
      formData.append("notificationDes", requestBody.notificationDes);
      formData.append("deptId", requestBody.deptId);
      formData.append("isDrafted", requestBody.isDrafted);
      formData.append("docTypeId", requestBody.docTypeId);
      formData.append("serviceAdvDesc", requestBody.serviceAdvDesc);
      formData.append("userDeptId", requestBody.userDeptId);
    }
    const response = await postFile(
      tokenHttpClient,
      `${BASE_URL}${API_URL.serviceAdvisoryUploadFile}`,
      formData
    );
    // add condition here to check
    if (response.status === 200) {
      const { data } = response;
      return data;
    } else {
      return [];
    }
  } catch (err) {
    console.log("errr catch", err);
    throw err;
  }
};

export const ServiceAdvisoryUpdatService = async (file, requestBody) => {
  try {
    let formData = new FormData();
    if (file) {
      var multifile = [];
      for (let i = 0; i < file.length; i++) {
        formData.append("file", file[i]);
        multifile.push(file[i]);
      }
      formData.append("modifiedBy", requestBody.modifiedBy);
      formData.append("advisoryNumber", requestBody.advisoryNumber);
      formData.append("modelId", requestBody.modelId);
      formData.append("releaseDate", requestBody.releaseDate);
      formData.append("isDownloadAble", requestBody.isDownloadAble);
      formData.append("sendNotification", requestBody.sendNotification);
      formData.append("notificationDes", requestBody.notificationDes);
      formData.append("deptId", requestBody.deptId);
      formData.append("isDrafted", requestBody.isDrafted);
      formData.append("docTypeId", requestBody.docTypeId);
      formData.append("serviceAdvDesc", requestBody.serviceAdvDesc);
      formData.append("oldAdvisoryNumber", requestBody.oldAdvisoryNumber);
      formData.append("userDeptId", requestBody.userDeptId);
    }
    else{
      formData.append("modifiedBy", requestBody.modifiedBy);
      formData.append("advisoryNumber", requestBody.advisoryNumber);
      formData.append("modelId", requestBody.modelId);
      formData.append("releaseDate", requestBody.releaseDate);
      formData.append("isDownloadAble", requestBody.isDownloadAble);
      formData.append("sendNotification", requestBody.sendNotification);
      formData.append("notificationDes", requestBody.notificationDes);
      formData.append("deptId", requestBody.deptId);
      formData.append("isDrafted", requestBody.isDrafted);
      formData.append("docTypeId", requestBody.docTypeId);
      formData.append("serviceAdvDesc", requestBody.serviceAdvDesc);
      formData.append("oldAdvisoryNumber", requestBody.oldAdvisoryNumber);
      formData.append("userDeptId", requestBody.userDeptId);
    }
    
    const response = await postFile(
      tokenHttpClient,
      `${BASE_URL}${API_URL.serviceAdvisoryUpdateFile}`,
      formData
    );
    // add condition here to check
    if (response.status === 200) {
      const { data } = response;
      return data;
    } else {
      return [];
    }
  } catch (err) {
    console.log("errr catch", err);
    throw err;
  }
};

export const ModelListingService = async (brickId, brandId) => {
  try {
    const param = {
      brickId,
      brandId,
    };
    
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.serviceAdvisoryModelListing}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ModeDeptListingService = async (brickId, brandId,advisoryNumber) => {
  try {
    
    const param = {
     
      brickId: brickId,
      brandId: brandId,
      advisoryNumber: advisoryNumber,
  };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.serviceAdvisoryModelDeptListing}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const ModelDescriptionOnSelectedModelService = async (modelId) => {
  try {
    const param = {
      modelId,
    };
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.getModelDescriptionOnSelectedModelId}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const DownloadServiceAdvisoryService = async (id) => {
  try {
    const response = await getWithURLFileDownload(
      tokenHttpClient,
      `${BASE_URL}${API_URL.getAdvisoryDocs}`,
      {
        id,
      }
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};
export const ChangeServicAdvStatusService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.changeServiceAdvStatus}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const getModelandDeptDetailAdvService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.modelAndDeptAdvDetail}?advisoryNumber=${requestBody.advisoryNumber}`,
      null
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const deleteServiceAdvisoryService = async (requestBody) => {
  try {
    const response = await post(
      tokenHttpClient,
      `${BASE_URL}${API_URL.deleteServiceAdvisory}`,
      requestBody
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
}